export enum UserGroups {
    Sales = 'sales',
    Ops = 'ops',
    OpsManagers = 'opsmanagers',
}
